module.exports = __webpack_public_path__ + "static/media/package_care_40_hours.fab1a391.svg";